// src/eventslive/elFmt.ts — date + name formatters for the Events Live volunteer
// surfaces. Ported from the approved prototype (events-live/tokens.jsx) so copy
// renders identically. All ISO dates are "YYYY-MM-DD"; parsed at UTC midnight to
// dodge timezone off-by-one.

const WD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const WD_LONG = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MO = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const MO_LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function isoDate(iso: string): Date { return new Date(iso + "T00:00:00Z"); }
export function wdShort(iso: string): string { return WD[isoDate(iso).getUTCDay()]!; }
export function wdLong(iso: string): string { return WD_LONG[isoDate(iso).getUTCDay()]!; }
export function dayNum(iso: string): number { return isoDate(iso).getUTCDate(); }
export function moShort(iso: string): string { return MO[isoDate(iso).getUTCMonth()]!; }
export function fmtDayChip(iso: string): string { return `${wdShort(iso)} ${dayNum(iso)} ${moShort(iso)}`; }
export function fmtLong(iso: string): string { const d = isoDate(iso); return `${WD_LONG[d.getUTCDay()]} ${d.getUTCDate()} ${MO_LONG[d.getUTCMonth()]}`; }
export function fmtDateRange(days: string[]): string {
  if (!days.length) return "";
  const a = isoDate(days[0]!); const b = isoDate(days[days.length - 1]!);
  if (days.length === 1) return `${WD_LONG[a.getUTCDay()]!.slice(0, 3)} ${a.getUTCDate()} ${MO[a.getUTCMonth()]} ${a.getUTCFullYear()}`;
  return `${a.getUTCDate()} ${MO[a.getUTCMonth()]} – ${b.getUTCDate()} ${MO[b.getUTCMonth()]} ${b.getUTCFullYear()}`;
}
export function firstName(name: string | null | undefined): string { return (name || "").split(" ")[0] || ""; }

export function fmtClock(d: Date): string {
  return d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
}
export function fmtHM(d: Date): string {
  return d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
}
export function fmtDuration(min: number): string {
  const h = Math.floor(min / 60), m = min % 60;
  return `${String(h).padStart(2, "0")}h ${String(m).padStart(2, "0")}m`;
}
